import _objectSpread from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { path } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var generateOTP = function generateOTP(axios, email, otpEmailTemplateName) {
  return axios.post(urls.apiV3("/prepaid-cards/otp"), _objectSpread({
    email: email
  }, otpEmailTemplateName && {
    otpEmailTemplateName: otpEmailTemplateName
  })).then(path(['data', 'data']));
};
var getById = function getById(axios, id) {
  return axios.get(urls.apiV3("/prepaid-cards/".concat(id))).then(path(['data', 'data']));
};

// The readiness poll while a card is created and funded: a small projection
// on its own path, outside the other prepaid-card routes' rate-limit bucket.
var getStatusById = function getStatusById(axios, id) {
  return axios.get(urls.apiV3("/prepaid-cards/".concat(id, "/status"))).then(path(['data', 'data']));
};
var getSensitiveCardDetails = function getSensitiveCardDetails(axios, id) {
  return axios.get(urls.apiV3("/prepaid-cards/".concat(id, "/details"))).then(path(['data', 'data']));
};
var reportMisuse = function reportMisuse(axios, id, status) {
  return axios.post(urls.apiV3("/prepaid-cards/".concat(id, "/report-misuse")), {
    status: status
  }).then(path(['data', 'data']));
};
export default {
  generateOTP: withAxios(generateOTP),
  getById: withAxios(getById),
  getStatusById: withAxios(getStatusById),
  getSensitiveCardDetails: withAxios(getSensitiveCardDetails),
  reportMisuse: withAxios(reportMisuse)
};